import AgTechWebApp from "@agtech/web/components/App/Templates/App/AgTechWebApp";
import { SalesAppDataStore } from '@sales/data/SalesAppDataStore'
import SalesAppHeader from "./layout/SalesAppHeader";
import SalesAppSideNavigationMenu from "./layout/SalesAppSideNavigationMenu";
import SalesAppHomePage from "./SalesAppHomePage";
import BackgroundImage from '../resources/Landing.jpg';
import SalesAppDataContext from "@sales/data/SalesAppDataContext";
import SalesAppLandingPage from "./SalesAppLandingPage";
import SalesAppSetupModal from "./SalesAppSetupModal";
import { AgTechWebApplication } from "@agtech/web/application/AgTechWebApplication";
import { SaleOperationDataGetRegistrationStatusQuery } from "@sales/data/operation/SaleDataOperationQueries";
import { SaleOperationDataCompleteOperationSetupAction, SaleOperationDataRegisterOperationAction } from "@sales/data/operation/SaleDataOperationActions";
import { SaleDataGetSalesQuery } from "@sales/data/sales/SaleDataQueries";
import { OperationDataGetOperationLogoQuery } from "@agtech/data/operations/OperationDataQueries";
import { SaleFeatureDataGetFeaturesQuery } from "@sales/data/features/SaleFeatureData";

const SalesWebApp: AgTechWebApplication = {
    name: 'Sellabull',
    icon: 'fas fa-balance-scale-left',
    structure: {
        landingPage: () => <SalesAppLandingPage />,
        homePage: {
            name: 'Home',
            text: 'Home',
            workspace: () => <SalesAppHomePage />
        },
        dataContext: props => <SalesAppDataContext {...props} />,
        header: { show: false },
        sideNavigation: app => <SalesAppSideNavigationMenu app={app} />,
    },
    data: {
        baseURL: process.env.REACT_APP_API_URL + '',
        //baseURL: 'https://sellabull.dakotaagtech.com',
        dataStore: SalesAppDataStore
    },
    registration: {
        registrationStatusQuery: { query: SaleOperationDataGetRegistrationStatusQuery },
        registrationAction: SaleOperationDataRegisterOperationAction,
        termsOfService: () => (<></>),
    },
    setup: {
        completeSetupAction: SaleOperationDataCompleteOperationSetupAction,
        setupModal: () => ({
            modal: SalesAppSetupModal,
            height: '720px',
            width: '1200px'
        })
    },
    loading: {
        queries: () => [
            { query: OperationDataGetOperationLogoQuery },
            { query: SaleDataGetSalesQuery }
        ]
    },
    auth: {
        authority: process.env.REACT_APP_AUTHORITY + '',
        clientId: process.env.REACT_APP_CLIENT_ID + '',
        clientSecret: process.env.REACT_APP_CLIENT_SECRET + '',
        redirectUri: process.env.REACT_APP_BASE_URL + '/auth/login',
        silentRedirectUri: process.env.REACT_APP_BASE_URL + '/auth/login',
        postLogoutRedirectUri: process.env.REACT_APP_BASE_URL + '',
        responseType: process.env.REACT_APP_RESPONSE_TYPE + '',
        scopes: process.env.REACT_APP_SCOPES + '',
        usesAuth: true
    },
    features: {
        query: SaleFeatureDataGetFeaturesQuery
    },
    stripe: {
        publishableKey: 'pk_test_51Mfqa1Ip2rILbopoMC4utx89a162Dv4zVJq0GVgpVTTQ0nZh1Huql7OlolIiK5fVwISIlecAEJrEB4WaUP2UCLc200aoVreRV2'
    },
    backgroundImage: BackgroundImage
}

const SalesApp = () => {
    return (
        <AgTechWebApp app={SalesWebApp} />
    )
}

export default SalesApp;